import { apiCall } from "./service";
import {
  URL_PROJECTS,
  URL_PROGRAM,
  URL_PORTFOLIO,
  URL_CHANGE_REQUEST,
  URL_CREATE_CHANGE_REQUEST,
  URL_UPDATE_CHANGE_REQUEST,
  URL_DELETE_CHANGE_REQUEST,
  URL_CHANGE_REQUEST_FLAG,
  URL_CREATE_CHANGE_REQUEST_RISK,
  BASE_URL,
} from "./URL";

export const api = {
  sortChangeRequests(params) {
    if (params.parent === "Change Request") {
      return apiCall.pagination({
        url: `${URL_CHANGE_REQUEST}?pageNumber=${params.page}&pageSize=${params.size}&orderBy=${params.orderBy}`,
        isAuthToken: true,
      });
    }
    if (params.parent === "Project") {
      return apiCall.pagination({
        url: `${URL_PROJECTS}/${params.id}/changeRequests?pageNumber=${params.page}&pageSize=${params.size}&orderBy=${params.orderBy}`,
        isAuthToken: true,
      });
    }
    if (params.parent === "Program") {
      return apiCall.pagination({
        url: `${URL_PROGRAM}${params.id}/changeRequests?pageNumber=${params.page}&pageSize=${params.size}&orderBy=${params.orderBy}`,
        isAuthToken: true,
      });
    }
    if (params.parent === "Portfolio") {
      return apiCall.pagination({
        url: `${URL_PORTFOLIO}/${params.id}/changeRequests?pageNumber=${params.page}&pageSize=${params.size}&orderBy=${params.orderBy}`,
        isAuthToken: true,
      });
    }
  },

  getChangeRequests(params) {
    const { parent, search, id, page, size } = params;
    const paginationParams = { pageNumber: page, pageSize: size };
    let url;

    switch (parent) {

      case "Portfolio":
        url = `${BASE_URL}Portfolios/${id}/ChangeRequests`;
        break;

      case "Program":
        url = `${BASE_URL}Programs/${id}/ChangeRequests`;
        break;

      case "Project":
        url = `${BASE_URL}Projects/${id}/ChangeRequests`;
        break;

      default:
        url = `${BASE_URL}ChangeRequests`;
    }

    if (search) {
      paginationParams.searchTerm = search;
    }

    const queryParams = new URLSearchParams(paginationParams).toString();
    const fullUrl = `${url}?${queryParams}`;

    return apiCall.pagination({ url: fullUrl });
  },

  fetchSingleChangeRequest(id) {
    return apiCall.get({ url: `${URL_CHANGE_REQUEST}${id}` });
  },

  createChangeRequest(params) {
    return apiCall.post({
      url: `${URL_CREATE_CHANGE_REQUEST}`,
      isAuthToken: true,
      params: params.payload,
    });
  },

  updateChangeRequest(params) {
    return apiCall.put({
      url: `${URL_UPDATE_CHANGE_REQUEST}${params.id}`,
      isAuthToken: true,
      params: params.payload,
    });
  },

  deleteChangeRequest(params) {
    return apiCall.delete({
      url: `${URL_DELETE_CHANGE_REQUEST}${params.id}`,
      isAuthToken: true,
      params,
    });
  },

  createChangeRequestRisk(params) {
    return apiCall.post({
      url: `${URL_CREATE_CHANGE_REQUEST_RISK}`,
      isAuthToken: true,
      params: params.payload,
    });
  },

  updateChangeRequestFlag(params) {
    return apiCall.patch({
      url: `${URL_CHANGE_REQUEST_FLAG}${params.id}`,
      isAuthToken: true,
      params: params.payload,
    });
  },
};

export default api;
